import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { selectCaseById } from '@debbie/cortex/dist/cases/selectors.js';
import { selectCustomerById } from '@debbie/cortex/dist/customers/selectors.js';
const DebtorData = styled.p `
  margin: 0.3em 0;

  .debtor-request-data {
    color: black;
    font-weight: bold;
  }
`;
const PersonalDataRequest = (props) => {
    const { data, referenceId, createdByAccount } = props.item;
    const lang = useSelector((s) => s.lang);
    const addressData = data && data.address;
    const selectedCase = useSelector((s) => selectCaseById(s, referenceId));
    const customer = useSelector((s) => selectedCase && selectCustomerById(s, selectedCase.customerId));
    const debtor = customer && customer.users.find((d) => d.userId === createdByAccount);
    return (data && (React.createElement("div", null,
        addressData && (React.createElement(DebtorData, null,
            React.createElement("b", null,
                debtor && `@${debtor.id}`,
                " ",
                lang.debtorInfo.address,
                ' '),
            React.createElement("small", { className: "debtor-request-data" }, `${addressData.address}, ${addressData.zipcode} ${addressData.city} ${addressData.country ? addressData.country : ''}`))),
        data.email && (React.createElement(DebtorData, null,
            React.createElement("b", null,
                debtor && `@${debtor.id}`,
                " ",
                lang.debtorInfo.email,
                ' '),
            React.createElement("small", { className: "debtor-request-data" }, data.email))),
        data.name && (React.createElement(DebtorData, null,
            React.createElement("b", null,
                debtor && `@${debtor.id}`,
                " ",
                lang.debtorInfo.name,
                ' '),
            React.createElement("small", { className: "debtor-request-data" }, data.name))),
        data.phone && (React.createElement(DebtorData, null,
            React.createElement("b", null,
                debtor && `@${debtor.id}`,
                " ",
                lang.debtorInfo.phone,
                ' '),
            React.createElement("small", { className: "debtor-request-data" }, data.phone))),
        data.cpr && (React.createElement(DebtorData, null,
            React.createElement("b", null,
                debtor && `@${debtor.id}`,
                " ",
                lang.debtorInfo.cpr,
                ' '),
            React.createElement("small", { className: "debtor-request-data" }, data.cpr))),
        data.cvr && (React.createElement(DebtorData, null,
            React.createElement("b", null,
                debtor && `@${debtor.id}`,
                " ",
                lang.debtorInfo.cvr,
                ' '),
            React.createElement("small", { className: "debtor-request-data" }, data.cvr))))));
};
export default PersonalDataRequest;
//# sourceMappingURL=PersonalDataRequest.js.map